import React, { useEffect, useState, useContext, useRef } from "react";
import "../styles/Header.scss";
import { FaArrowLeftLong } from "react-icons/fa6";
import imagelogosm from "../images/neubox-logo.png";
import imagelogo from "../images/logo-icon.png";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../Auth";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ic_user from "../images/icon/ic-user-white.svg";
import ic_userorange from "../images/icon/ic-user-orange.svg";
import ic_panel from "../images/icon/ic-panel.svg";
import ic_cerrar from "../images/icon/ic-cerrar.svg";
import HeaderOldCart from "./HeaderOldCart";
import LogInModal from "./Login/LogInModal";
import RegisterModal from "./Login/RegisterModal";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import CardButton from "./Header/CardButton";

function Header({ confirmPay, onlyLogo = false, changeCart = false, showCartCount = false }) {
  const location = useLocation();
  const { t } = useTranslation();
  const urlPanel = process.env.REACT_APP_CLIENTES_URL;
  const isCheckout = location.pathname === "/checkout";
  const resumenData = useSelector((state) => state.global.ResumenData);
  const idproduct = useSelector((state) => state.global.idproduct);
  const countActualTrue = resumenData.filter((item) => item.actual === false).length;
  const profile = useSelector((state) => state.profile);
  const [buttonText, setButtonText] = useState(t("header.btn.user"));
  const rowHeader = useRef(null);
  const contentHeader = useRef(null);
  const [height, setHeight] = useState(0);
  const { logout } = useContext(AuthContext);
  const handleCloseRegister = () => setIsRegisterOpen(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const urlBaseV4 = process.env.REACT_APP_V4_BASE_URL;

  const formattedName = () => {
    const nameParts = profile.name.split(" ");
    let firstName = nameParts[0].slice(0, 13); // Get the first 13 characters of the first name
    const lastNameInitial = nameParts.length > 1 ? nameParts[1][0] + "." : "";

    // Adjust the first name length to fit within the 15 character limit
    const totalLength = firstName.length + lastNameInitial.length;
    if (totalLength > 15) {
      firstName = firstName.slice(0, 15 - lastNameInitial.length);
    }

    return `${firstName} ${lastNameInitial}`;
  };

  useEffect(() => {
    if (profile.name) {
      setButtonText(formattedName());
    } else {
      setButtonText(t("header.btn.user"));
    }
  }, [profile]);

  useEffect(() => {
    const element = contentHeader.current;
    if (!element) return;

    // Callback que se ejecuta cuando el tamaño cambia
    const handleResize = (entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        setHeight(newHeight); // Actualizamos el estado con la nueva altura
      }
    };

    // Crear un ResizeObserver
    const observer = new ResizeObserver(handleResize);

    // Observar el elemento
    observer.observe(element);

    // Limpieza al desmontar el componente
    return () => observer.disconnect();
  }, []);

  // Acción al cambiar la altura
  useEffect(() => {
    const element = rowHeader.current;
    if (element) {
      element.style.height = height + "px";
    }
    // Realiza una acción aquí
  }, [height]);

  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  const handleOpenLogin = () => {
    setIsLoginOpen(true);
    setIsRegisterOpen(false);
  };

  const handleCloseLogin = () => setIsLoginOpen(false);

  const handleOpenRegister = () => {
    setIsRegisterOpen(true);
    setIsLoginOpen(false);
  };

  const handleClickUser = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUser = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
  }

  return (
    <div className="row-header" ref={rowHeader}>
      <Box
        boxShadow={5}
        ref={contentHeader}
        style={{
          background: "#fff",
          width: "100%",
          position: "fixed",
          zIndex: 99,
        }}
      >
        {changeCart && <HeaderOldCart />}

        <Box className="header-content">
          {!onlyLogo && confirmPay && (!idproduct || isCheckout) && (
            <div className="header-left">
              <button className="header-seguir">
                <a href={urlBaseV4}>
                  <FaArrowLeftLong className="icon-header" style={{ marginTop: 2 }} />
                  <span className="header-icons-txt">&nbsp;&nbsp;{t("header.btn.back")}</span>
                </a>
              </button>
            </div>
          )}
          <div className={"header-center " + (onlyLogo ? " center" : "")}>
            <img src={imagelogosm} alt="Logo Neubox" className="h-logo1" />
            <img src={imagelogo} alt="Logo Icon" className="h-logo2" />
          </div>

          {!onlyLogo && (
            <div className="header-right">
              <div className="header-buttons">
                { buttonText == t("header.btn.user") &&
                  <button className="btn header-sign" onClick={handleOpenLogin}>
                    <img src={ic_user} alt="icono iniciar sesión" />
                    <span className="header-icons-txt">&nbsp;&nbsp;{buttonText}</span>
                  </button>
                }
                { buttonText != t("header.btn.user") &&
                  <Tooltip title={t("header.sing.cerrar")}>
                    <IconButton
                      className="btn header-sign"
                      onClick={handleClickUser}
                      size="small"
                      sx={{ ml: 2 }}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      aria-controls={open ? 'account-menu' : undefined}
                    >
                      <img src={ic_user} alt="icono iniciar sesión" />
                      <span className="header-icons-txt">&nbsp;&nbsp;{buttonText}</span>
                    </IconButton>
                  </Tooltip>

                  
                }
                <LogInModal 
                  open={isLoginOpen} 
                  onClose={handleCloseLogin} 
                  onOpenRegister={handleOpenRegister} 
                  onCloseRegister={handleCloseRegister}
                />
                <RegisterModal 
                  open={isRegisterOpen} 
                  onClose={handleCloseRegister} 
                  onOpenLogin={handleOpenLogin} 
                />
              </div>

              {showCartCount && (<CardButton countActualTrue={countActualTrue}/>)}
            </div>
          )}
        </Box>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleCloseUser}
        onClick={handleCloseUser}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              minWidth: 180,
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <div className="headerLogin">
          <div className="headerLogin-cuenta">CUENTA</div>
          <div className="headerLogin-content">
            <img src={ic_userorange} alt="icono iniciar sesión" />
            <div className="headerLogin-content-info">
              <span className="headerLogin-content-info-name">{profile.name}</span>
              <span className="headerLogin-content-info-mail">{profile.email}</span>
            </div>
          </div>
        </div>
        <Divider />
        <Link href={urlPanel} color="inherit" underline="none">
          <MenuItem className="headerLogin-menu-panel">
            {t("header.sing.panel")}
            <img className="headerLogin-img2" src={ic_panel} alt="icono panel clientes" />
          </MenuItem>
        </Link>
        <Divider />
        <MenuItem className="headerLogin-menu-cerrar" onClick={handleLogout}>
          {t("header.sing.cerrar")}
          <img className="headerLogin-img" src={ic_cerrar} alt="icono cerrar sesión" />
        </MenuItem>
      </Menu>
    </div>
  );
}

export default Header;
